export enum AuthStrategy {
	ANONYMOUS = 'anonymous',
	CREDENTIALS = 'credentials',
	CREDENTIALS_BY_MAIL = 'credentials_by_mail',
	APPLE = 'apple',
	FACEBOOK = 'facebook',
	GOOGLE = 'google'
}
